/**
 * @generated SignedSource<<64abe4cda5f284d3189d748d30ae02a2>>
 * @relayHash b291183164e54b61ac41c7ac3a91ac01
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0f7a323c6163ddb2c5139bf05639e0215bef2eaec201056a60dd9d2dbcdb646d

import type { ConcreteRequest } from 'relay-runtime';
export type EnableSuperAdminMutation$variables = Record<PropertyKey, never>;
export type EnableSuperAdminMutation$data = {
  readonly enableSuperAdmin: {
    readonly user: {
      readonly confluence: {
        readonly roles: {
          readonly isSuperAdmin: boolean;
        } | null | undefined;
      } | null | undefined;
      readonly id: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type EnableSuperAdminMutation = {
  response: EnableSuperAdminMutation$data;
  variables: EnableSuperAdminMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "concreteType": "ConfluenceUser",
      "kind": "LinkedField",
      "name": "confluence",
      "plural": false,
      "selections": [
        {
          "concreteType": "GraphQLConfluenceUserRoles",
          "kind": "LinkedField",
          "name": "roles",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isSuperAdmin"
            }
          ]
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "EnableSuperAdminMutation",
    "selections": [
      {
        "concreteType": "SuperAdminPayload",
        "kind": "LinkedField",
        "name": "enableSuperAdmin",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "EnableSuperAdminMutation",
    "selections": [
      {
        "concreteType": "SuperAdminPayload",
        "kind": "LinkedField",
        "name": "enableSuperAdmin",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v0/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "b291183164e54b61ac41c7ac3a91ac01",
    "id": "0f7a323c6163ddb2c5139bf05639e0215bef2eaec201056a60dd9d2dbcdb646d",
    "metadata": {},
    "name": "EnableSuperAdminMutation",
    "operationKind": "mutation",
    "text": "mutation EnableSuperAdminMutation{enableSuperAdmin{user{id,confluence{roles{isSuperAdmin}}},id}}"
  }
};
})();

(node as any).hash = "4e0079a7f1ee60e3ad64031d0daad593";

export default node;
